<script setup>
import { ref, onMounted } from "vue";
import { getExchangeRate } from "@/apis/exchangeRate";

defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close"]);

const rate = ref(null);

onMounted(async () => {
  const { exchange_rate } = await getExchangeRate();
  rate.value = exchange_rate;
});

const goChatbot = () => {
  if (typeof window === "undefined") return;

  gtag("event", "Index_click", { action: "goChatbot", page: "mobile_menu" });
  if (localStorage.utm_ref != null) {
    window.open(
      "https://chatxbuy-springboard.web.app?ref=" + localStorage.utm_ref,
    );
  } else {
    window.open("https://chatxbuy-springboard.web.app");
  }
  emit("close");
};

const handleMenuClick = () => {
  emit("close");
};

const handleOverlayClick = () => {
  emit("close");
};
</script>

<template>
  <!-- 遮罩層 -->
  <Transition name="overlay">
    <div
      v-if="isOpen"
      class="mobile-menu-overlay"
      @click="handleOverlayClick"
    ></div>
  </Transition>

  <!-- 選單內容 -->
  <Transition name="slide">
    <div v-if="isOpen" class="mobile-menu">
      <div class="divider"></div>

      <div class="menu-container">
        <div class="menu-link" @click="handleMenuClick">
          <router-link to="/">
            <span class="menu-text">首頁</span>
          </router-link>
        </div>

        <div class="menu-link" @click="handleMenuClick">
          <router-link to="/page/service">
            <span class="menu-text">服務介紹</span>
          </router-link>
        </div>

        <div class="menu-link" @click="handleMenuClick">
          <router-link to="/page/freight">
            <span class="menu-text">費用說明</span>
          </router-link>
        </div>

        <div class="menu-link" @click="handleMenuClick">
          <router-link to="/page/faq">
            <span class="menu-text">Q&A</span>
          </router-link>
        </div>

        <div class="menu-link" @click="handleMenuClick">
          <router-link to="/page/blogList">
            <span class="menu-text">Blog</span>
          </router-link>
        </div>

        <div class="menu-link" @click="handleMenuClick">
          <router-link to="/page/aboutUs">
            <span class="menu-text">關於我們</span>
          </router-link>
        </div>

        <img
          style="cursor: pointer"
          @click="goChatbot"
          src="@/assets/images/mobile/header/Primary.svg"
          alt="代買幫"
        />

        <p class="exchange-rate">
          今日匯率：新台幣
          <span class="rate-value">{{ rate }}</span>
        </p>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
/* 遮罩層 */
.mobile-menu-overlay {
  position: fixed;
  top: 72px; /* Header 高度 */
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
}

/* 選單主體 */
.mobile-menu {
  position: fixed;
  top: 72px; /* Header 高度 */
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  z-index: 999;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: #dee2e6;
}

.menu-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-block: 40px;
  gap: 36px;
}

.menu-link a {
  text-decoration: none;
  color: inherit;
}

.menu-text {
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0;
  font-family: "PingFang TC";
  font-size: 18px;
}

.exchange-rate {
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0;
  font-size: 14px;
}

.rate-value {
  color: #3c5bff;
  font-weight: 600;
  padding-inline: 4px;
}

/* 桌面版隱藏 */
@media (min-width: 1060px) {
  .mobile-menu,
  .mobile-menu-overlay {
    display: none;
  }
}

/* 遮罩層動畫 */
.overlay-enter-active,
.overlay-leave-active {
  transition: opacity 0.3s ease;
}

.overlay-enter-from,
.overlay-leave-to {
  opacity: 0;
}

/* 選單滑動動畫（從上方滑入）*/
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(-100%);
}
</style>
